var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { getPath, template, simpleMetadataDecoratorApplicator } from "@spscommerce/utils";
var StdButtonKind;
(function(StdButtonKind2) {
  StdButtonKind2["DEFAULT"] = "default";
  StdButtonKind2["CONFIRM"] = "confirm";
  StdButtonKind2["DELETE"] = "delete";
  StdButtonKind2["KEY"] = "key";
})(StdButtonKind || (StdButtonKind = {}));
var ButtonKindIcon;
(function(ButtonKindIcon2) {
  ButtonKindIcon2["ICON"] = "icon";
})(ButtonKindIcon || (ButtonKindIcon = {}));
var ButtonKindLink;
(function(ButtonKindLink2) {
  ButtonKindLink2["LINK"] = "link";
})(ButtonKindLink || (ButtonKindLink = {}));
const DropdownKind = Object.freeze(__spreadValues(__spreadValues({}, StdButtonKind), ButtonKindIcon));
const ButtonKind = Object.freeze(__spreadValues(__spreadValues(__spreadValues({}, StdButtonKind), ButtonKindIcon), ButtonKindLink));
var ButtonType;
(function(ButtonType2) {
  ButtonType2["BUTTON"] = "button";
  ButtonType2["SUBMIT"] = "submit";
})(ButtonType || (ButtonType = {}));
var SelectMode;
(function(SelectMode2) {
  SelectMode2[SelectMode2["START"] = 0] = "START";
  SelectMode2[SelectMode2["END"] = 1] = "END";
})(SelectMode || (SelectMode = {}));
var ClickableTagKind;
(function(ClickableTagKind2) {
  ClickableTagKind2["BLUE"] = "blue";
  ClickableTagKind2["GRAY"] = "gray";
})(ClickableTagKind || (ClickableTagKind = {}));
function exampleIsReactComponentExample(example) {
  return example.hasOwnProperty("react");
}
function exampleIsReactJSXExample(example) {
  return example.hasOwnProperty("jsx");
}
var SpsIconSize;
(function(SpsIconSize2) {
  SpsIconSize2["EXTRA_SMALL"] = "xs";
  SpsIconSize2["SMALL"] = "sm";
  SpsIconSize2["MEDIUM"] = "md";
  SpsIconSize2["LARGE"] = "lg";
  SpsIconSize2["EXTRA_LARGE"] = "xl";
})(SpsIconSize || (SpsIconSize = {}));
var SpsIcon;
(function(SpsIcon2) {
  SpsIcon2["ANGLE_LEFT"] = "angle-left";
  SpsIcon2["ANGLE_RIGHT"] = "angle-right";
  SpsIcon2["ARCHIVE"] = "archive";
  SpsIcon2["ARCHIVE_CIRCLE"] = "archive-circle";
  SpsIcon2["ARROW_DOWN"] = "arrow-down";
  SpsIcon2["ARROW_LEFT"] = "arrow-left";
  SpsIcon2["ARROW_LEFT_CIRCLE"] = "arrow-left-circle";
  SpsIcon2["ARROW_RIGHT"] = "arrow-right";
  SpsIcon2["ARROW_RIGHT_CIRCLE"] = "arrow-right-circle";
  SpsIcon2["ARROW_UP"] = "arrow-up";
  SpsIcon2["ASTERISK"] = "asterisk";
  SpsIcon2["ASTERISK_CIRCLE"] = "asterisk-circle";
  SpsIcon2["BAN"] = "ban";
  SpsIcon2["BAN_CIRCLE"] = "ban-circle";
  SpsIcon2["BARCODE"] = "barcode";
  SpsIcon2["BELL"] = "bell";
  SpsIcon2["BELL_FILLED"] = "bell-filled";
  SpsIcon2["BOLT"] = "bolt";
  SpsIcon2["BOOK"] = "book";
  SpsIcon2["BUILDING"] = "building";
  SpsIcon2["BURST"] = "burst";
  SpsIcon2["BURST_BOLT"] = "burst-bolt";
  SpsIcon2["CALENDAR"] = "calendar";
  SpsIcon2["CALENDAR_BLANK"] = "calendar-blank";
  SpsIcon2["CALENDAR_BLANK_CIRCLE"] = "calendar-blank-circle";
  SpsIcon2["CALENDAR_SELECT"] = "calendar-select";
  SpsIcon2["CAMERA"] = "camera";
  SpsIcon2["CHART_AREA"] = "chart-area";
  SpsIcon2["CHART_BAR"] = "chart-bar";
  SpsIcon2["CHART_LINE"] = "chart-line";
  SpsIcon2["CHART_PIE"] = "chart-pie";
  SpsIcon2["CHECKMARK"] = "checkmark";
  SpsIcon2["CHECKMARK_CIRCLE"] = "checkmark-circle";
  SpsIcon2["CHEVRON_DOWN"] = "chevron-down";
  SpsIcon2["CHEVRON_LEFT"] = "chevron-left";
  SpsIcon2["CHEVRON_RIGHT"] = "chevron-right";
  SpsIcon2["CHEVRON_UP"] = "chevron-up";
  SpsIcon2["CIRCLE_OUTLINE"] = "circle-outline";
  SpsIcon2["CLOCK"] = "clock";
  SpsIcon2["CLOCK_CIRCLE"] = "clock-circle";
  SpsIcon2["CODE_FORK"] = "code-fork";
  SpsIcon2["COLUMN_SWITCHER"] = "column-switcher";
  SpsIcon2["COMMENT_BUBBLE"] = "comment-bubble";
  SpsIcon2["COMMENT_BUBBLE_QUESTION"] = "comment-bubble-question";
  SpsIcon2["CONVERSATION"] = "conversation";
  SpsIcon2["CREDIT_CARD"] = "credit-card";
  SpsIcon2["DASHBOARD"] = "dashboard";
  SpsIcon2["DATABASE"] = "database";
  SpsIcon2["DESCENDING_ELLIPSES_CIRCLE"] = "descending-ellipses-circle";
  SpsIcon2["DISK"] = "disk";
  SpsIcon2["DISK_CIRCLE"] = "disk-circle";
  SpsIcon2["DOLLAR_SIGN"] = "dollar-sign";
  SpsIcon2["DOUBLE_ANGLE_LEFT"] = "double-angle-left";
  SpsIcon2["DOUBLE_ANGLE_RIGHT"] = "double-angle-right";
  SpsIcon2["DOWNLOAD_CLOUD"] = "download-cloud";
  SpsIcon2["DRILL"] = "drill";
  SpsIcon2["DUPLICATE"] = "duplicate";
  SpsIcon2["ELLIPSES"] = "ellipses";
  SpsIcon2["ENVELOPE"] = "envelope";
  SpsIcon2["EXCHANGE"] = "exchange";
  SpsIcon2["EXCLAMATION_CIRCLE"] = "exclamation-circle";
  SpsIcon2["EXCLAMATION_TRIANGLE"] = "exclamation-triangle";
  SpsIcon2["EXPAND_COLLAPSE"] = "expand-collapse";
  SpsIcon2["EYE"] = "eye";
  SpsIcon2["EYE_SLASH"] = "eye-slash";
  SpsIcon2["FILE"] = "file";
  SpsIcon2["FILE_DUPLICATE"] = "file-duplicate";
  SpsIcon2["FILE_PDF"] = "file-pdf";
  SpsIcon2["FILE_PRESENTATION"] = "file-presentation";
  SpsIcon2["FILE_SIZE"] = "file-size";
  SpsIcon2["FILE_SOLID"] = "file-solid";
  SpsIcon2["FILE_SOLID_TEXT"] = "file-solid-text";
  SpsIcon2["FILE_SPREADSHEET"] = "file-spreadsheet";
  SpsIcon2["FILE_TEXT"] = "file-text";
  SpsIcon2["FILTER"] = "filter";
  SpsIcon2["FLAG"] = "flag";
  SpsIcon2["FOLDER"] = "folder";
  SpsIcon2["FOLDER_OPEN"] = "folder-open";
  SpsIcon2["FOLDER_SOLID"] = "folder-solid";
  SpsIcon2["FOLDER_SOLID_OPEN"] = "folder-solid-open";
  SpsIcon2["GEAR"] = "gear";
  SpsIcon2["GLOBE"] = "globe";
  SpsIcon2["GRID"] = "grid";
  SpsIcon2["GROUP"] = "group";
  SpsIcon2["HAND_STOP"] = "hand-stop";
  SpsIcon2["HANDSHAKE"] = "handshake";
  SpsIcon2["HAT"] = "hat";
  SpsIcon2["HEART"] = "heart";
  SpsIcon2["HISTORY"] = "history";
  SpsIcon2["INBOX"] = "inbox";
  SpsIcon2["INCOMING"] = "incoming";
  SpsIcon2["INFO_CIRCLE"] = "info-circle";
  SpsIcon2["INTERCOM"] = "intercom";
  SpsIcon2["ITEM_TAG"] = "item-tag";
  SpsIcon2["KEY"] = "key";
  SpsIcon2["LIFE_PRESERVER"] = "life-preserver";
  SpsIcon2["LIGHTBULB"] = "lightbulb";
  SpsIcon2["LINK"] = "link";
  SpsIcon2["LINKEDIN"] = "linkedin";
  SpsIcon2["LIST"] = "list";
  SpsIcon2["LIST_CARDS"] = "list-cards";
  SpsIcon2["LIST_COLUMNS"] = "list-columns";
  SpsIcon2["LIST_SUMMARY"] = "list-summary";
  SpsIcon2["LIST_TABLE"] = "list-table";
  SpsIcon2["LOCATION"] = "location";
  SpsIcon2["LOCKED"] = "locked";
  SpsIcon2["LOCKED_CIRCLE"] = "locked-circle";
  SpsIcon2["MAP"] = "map";
  SpsIcon2["MAP_MARKER"] = "map-marker";
  SpsIcon2["MAXIMIZE"] = "maximize";
  SpsIcon2["MINIMIZE"] = "minimize";
  SpsIcon2["MINUS"] = "minus";
  SpsIcon2["MINUS_CIRCLE"] = "minus-circle";
  SpsIcon2["NEW_FILE"] = "new-file";
  SpsIcon2["NEW_SCREEN"] = "new-screen";
  SpsIcon2["OUTGOING"] = "outgoing";
  SpsIcon2["PAPER_PLANE"] = "paper-plane";
  SpsIcon2["PENCIL"] = "pencil";
  SpsIcon2["PHOTO"] = "photo";
  SpsIcon2["PIN"] = "pin";
  SpsIcon2["PINTEREST"] = "pinterest";
  SpsIcon2["PLAY"] = "play";
  SpsIcon2["PLUS_CIRCLE"] = "plus-circle";
  SpsIcon2["PLUS_SIGN"] = "plus-sign";
  SpsIcon2["PRESENTATION"] = "presentation";
  SpsIcon2["PRINTER"] = "printer";
  SpsIcon2["QR_CODE"] = "qr-code";
  SpsIcon2["QUESTION_CIRCLE"] = "question-circle";
  SpsIcon2["QUOTE_LEFT"] = "quote-left";
  SpsIcon2["QUOTE_RIGHT"] = "quote-right";
  SpsIcon2["RANDOM"] = "random";
  SpsIcon2["REFRESH"] = "refresh";
  SpsIcon2["RIGHT_CIRCLE"] = "right-circle";
  SpsIcon2["ROCKET"] = "rocket";
  SpsIcon2["SEARCH"] = "search";
  SpsIcon2["SEARCH_PLUS"] = "search-plus";
  SpsIcon2["SHARE"] = "share";
  SpsIcon2["SHOPPING_CART"] = "shopping-cart";
  SpsIcon2["SORT_ALPHA_ASC"] = "sort-alpha-asc";
  SpsIcon2["SORT_ALPHA_DESC"] = "sort-alpha-desc";
  SpsIcon2["SORT_NUM_ASC"] = "sort-num-asc";
  SpsIcon2["SORT_NUM_DESC"] = "sort-num-desc";
  SpsIcon2["STAR"] = "star";
  SpsIcon2["STAR_OUTLINE"] = "star-outline";
  SpsIcon2["STATUS_ARCHIVED"] = "status-archived";
  SpsIcon2["STATUS_CANCELLED"] = "status-cancelled";
  SpsIcon2["STATUS_ERROR"] = "status-error";
  SpsIcon2["STATUS_IN_PROCESS"] = "status-in-process";
  SpsIcon2["STATUS_IN_TRANSIT"] = "status-in-transit";
  SpsIcon2["STATUS_LOCKED"] = "status-locked";
  SpsIcon2["STATUS_NEW"] = "status-new";
  SpsIcon2["STATUS_OK"] = "status-ok";
  SpsIcon2["STATUS_ON_HOLD"] = "status-on-hold";
  SpsIcon2["STATUS_OUTDATED"] = "status-outdated";
  SpsIcon2["STATUS_REJECTED"] = "status-rejected";
  SpsIcon2["STATUS_SAVED"] = "status-saved";
  SpsIcon2["STATUS_SAVING"] = "status-saving";
  SpsIcon2["STATUS_TEMPLATE"] = "status-template";
  SpsIcon2["STATUS_WARNING"] = "status-warning";
  SpsIcon2["TABLE"] = "table";
  SpsIcon2["TABS"] = "tabs";
  SpsIcon2["TAG"] = "tag";
  SpsIcon2["TEMPLATE_CIRCLE"] = "template-circle";
  SpsIcon2["THUMBS_DOWN"] = "thumbs-down";
  SpsIcon2["THUMBS_DOWN_OUTLINE"] = "thumbs-down-outline";
  SpsIcon2["THUMBS_UP"] = "thumbs-up";
  SpsIcon2["THUMBS_UP_OUTLINE"] = "thumbs-up-outline";
  SpsIcon2["TRASH"] = "trash";
  SpsIcon2["TRUCK_SHIPPING"] = "truck-shipping";
  SpsIcon2["TWITTER"] = "twitter";
  SpsIcon2["UNDO"] = "undo";
  SpsIcon2["UNLOCKED"] = "unlocked";
  SpsIcon2["UPLOAD_CLOUD"] = "upload-cloud";
  SpsIcon2["USER"] = "user";
  SpsIcon2["USER_IMPERSONATION"] = "user-impersonation";
  SpsIcon2["WRENCH"] = "wrench";
  SpsIcon2["X"] = "x";
  SpsIcon2["X_CIRCLE"] = "x-circle";
})(SpsIcon || (SpsIcon = {}));
var FeedbackBlockKind;
(function(FeedbackBlockKind2) {
  FeedbackBlockKind2["TIP"] = "tip";
  FeedbackBlockKind2["SUCCESS"] = "success";
  FeedbackBlockKind2["WARNING"] = "warning";
  FeedbackBlockKind2["ERROR"] = "error";
  FeedbackBlockKind2["INFO"] = "info";
})(FeedbackBlockKind || (FeedbackBlockKind = {}));
const FeedbackBlockIcons = Object.freeze({
  [FeedbackBlockKind.TIP]: SpsIcon.LIGHTBULB,
  [FeedbackBlockKind.ERROR]: SpsIcon.EXCLAMATION_CIRCLE,
  [FeedbackBlockKind.INFO]: SpsIcon.INFO_CIRCLE,
  [FeedbackBlockKind.SUCCESS]: SpsIcon.CHECKMARK,
  [FeedbackBlockKind.WARNING]: SpsIcon.EXCLAMATION_TRIANGLE
});
var SpsFilterTileKind;
(function(SpsFilterTileKind2) {
  SpsFilterTileKind2["GENERAL"] = "general";
  SpsFilterTileKind2["SUCCESS"] = "success";
  SpsFilterTileKind2["ERROR"] = "error";
  SpsFilterTileKind2["WARNING"] = "warning";
  SpsFilterTileKind2["PROCESSING"] = "processing";
})(SpsFilterTileKind || (SpsFilterTileKind = {}));
const GROWLER_VISIBLE_DURATION_MS = 7e3;
const GROWLER_FADEOUT_DURATION_MS = 2e3;
var GrowlerKind;
(function(GrowlerKind2) {
  GrowlerKind2["ACTIVITY"] = "activity";
  GrowlerKind2["ERROR"] = "error";
  GrowlerKind2["INFO"] = "info";
  GrowlerKind2["PROGRESS"] = "progress";
  GrowlerKind2["SUCCESS"] = "success";
  GrowlerKind2["WARNING"] = "warning";
})(GrowlerKind || (GrowlerKind = {}));
const GrowlerIcon = new Map([
  [GrowlerKind.INFO, SpsIcon.INFO_CIRCLE],
  [GrowlerKind.WARNING, SpsIcon.EXCLAMATION_TRIANGLE],
  [GrowlerKind.ERROR, SpsIcon.EXCLAMATION_CIRCLE],
  [GrowlerKind.SUCCESS, SpsIcon.CHECKMARK]
]);
var translations = { "advancedSearch": { "clear": "Clear Fields", "search": "Search" }, "button": { "spinningTitle": "Loading\u2026" }, "columnChooser": { "removeButton": "Remove {{elementName}}" }, "contentRow": { "collapse": "Collapse", "expand": "Expand" }, "datepicker": { "calendar": { "prevMonth": "View Previous Month", "nextMonth": "View Next Month" }, "preset": { "custom": "Custom", "today": "Today", "sevenDays": "Last 7 days", "thirtyDays": "Last 30 days", "sixtyDays": "Last 60 days", "ninetyDays": "Last 90 days", "oneYear": "Last year" }, "presetsLabel": "Ranges" }, "fileUpload": { "acceptedTypes": "{{fileTypes}} format accepted", "acceptedTypes_plural": "{{fileTypes}} formats accepted", "cancelled": "File Upload Failed", "cancelled_plural": "File Upload(s) Failed", "close": "Close", "instructions": "Drag and drop your file here or |browse for a file| on your desktop.", "instructions_plural": "Drag and drop your files here or |browse for files| on your desktop.", "maximumSize": "{{size}} maximum", "processing": "Processing Upload\u2026", "title": "Upload Your {{description}}" }, "filterPanel": { "clear": "Clear Filters", "title": "Filters", "filterPlaceholder": "Filter options" }, "focusedTask": { "close": "Close" }, "growler": { "dismiss": "Dismiss" }, "insightCard": { "all": "ALL", "partnerCount": "{{count}} |of| {{total}}", "partners": "PARTNERS" }, "insightTile": { "all": "ALL", "partnerCount": "{{count}} |of| {{total}}", "partners": "PARTNERS" }, "label": { "errors": { "dateConstraint": { "max": "Please enter a date on or prior to {{context.maxExceeded}}.", "min": "Please enter a date on or after {{context.minExceeded}}." }, "dateFormat": "Please enter a date in the format {{context}}.", "dateRangeOrder": "End date cannot be before start date.", "dateValidity": "Please enter a valid date.", "max": "Please enter a value no greater than {{context}}.", "maxLength": "Please enter no more than {{context}} characters.", "min": "Please enter a value no less than {{context}}.", "minLength": "Please enter at least {{context}} characters.", "required": "This field is required." }, "preventativeErrors": { "maxLength": "This field accepts a maximum number of characters.", "alpha": "This field accepts only alphabetic values.", "numeric": "This field accepts only numerical values.", "nonNumeric": "This field accepts only non-numerical values." }, "stronglySuggested": "This field is strongly suggested." }, "listActionBar": { "clearSelected": "Clear Selected", "itemsSelected": "Items Selected" }, "listToolbar": { "advancedSearchToggle": "Advanced Search" }, "modal": { "close": "Close modal", "defaultButtonLabel": "Okay", "defaultTitle": { "general": "Action", "info": "Info", "success": "Success", "warning": "Warning", "serious-warning": "Warning" } }, "pagination": { "nextPage": "Next Page", "ofMany": "of many", "ofPageCount": "of {{pageCount}}", "page": "Page", "prevPage": "Previous Page" }, "progressBar": { "closeButtonTitle": "Close progress bar" }, "searchResultsBar": { "clear": "Clear", "clearResults": "Clear Results", "count": "{{count}} of {{total}}", "matchingResults": "Matching results", "noAdvancedSearchSelections": "No Advanced Search Selections", "results": "Results:" }, "select": { "defaultPlaceholder": "Select one\u2026" }, "slackLink": { "label": "Chat" }, "spinner": { "defaultAltText": "Loading\u2026" }, "taskQueue": { "clearCompleted": "Clear Completed", "newTask": "You have a new task in your queue.", "noTasks": "There are currently no tasks in your queue." } };
const noI18nI18n = {
  t(key, interpolations) {
    const text = getPath(translations, key.replace(/^design-system:/, ""));
    return interpolations ? template(text)(interpolations) : text;
  }
};
var SpsInsightCardKind;
(function(SpsInsightCardKind2) {
  SpsInsightCardKind2["GENERAL"] = "general";
  SpsInsightCardKind2["SUCCESS"] = "success";
  SpsInsightCardKind2["ERROR"] = "error";
  SpsInsightCardKind2["WARNING"] = "warning";
  SpsInsightCardKind2["PROCESSING"] = "processing";
})(SpsInsightCardKind || (SpsInsightCardKind = {}));
const SpsInsightCardIcons = Object.freeze({
  [SpsInsightCardKind.GENERAL]: SpsIcon.STATUS_NEW,
  [SpsInsightCardKind.SUCCESS]: SpsIcon.STATUS_OK,
  [SpsInsightCardKind.ERROR]: SpsIcon.STATUS_ERROR,
  [SpsInsightCardKind.WARNING]: SpsIcon.STATUS_WARNING,
  [SpsInsightCardKind.PROCESSING]: SpsIcon.STATUS_IN_PROCESS
});
var SpsInsightTileKind;
(function(SpsInsightTileKind2) {
  SpsInsightTileKind2["GENERAL"] = "general";
  SpsInsightTileKind2["SUCCESS"] = "success";
  SpsInsightTileKind2["ERROR"] = "error";
  SpsInsightTileKind2["WARNING"] = "warning";
  SpsInsightTileKind2["PROCESSING"] = "processing";
})(SpsInsightTileKind || (SpsInsightTileKind = {}));
const SpsInsightTileIcons = Object.freeze({
  [SpsInsightTileKind.GENERAL]: SpsIcon.STATUS_NEW,
  [SpsInsightTileKind.SUCCESS]: SpsIcon.STATUS_OK,
  [SpsInsightTileKind.ERROR]: SpsIcon.STATUS_ERROR,
  [SpsInsightTileKind.WARNING]: SpsIcon.STATUS_WARNING,
  [SpsInsightTileKind.PROCESSING]: SpsIcon.STATUS_IN_PROCESS
});
var KeyValueListTitleColor;
(function(KeyValueListTitleColor2) {
  KeyValueListTitleColor2["LIGHT"] = "light";
  KeyValueListTitleColor2["DARK"] = "dark";
})(KeyValueListTitleColor || (KeyValueListTitleColor = {}));
var LineChartColors;
(function(LineChartColors2) {
  LineChartColors2["BLUE"] = "blue200";
  LineChartColors2["GRAY"] = "gray600";
  LineChartColors2["GREEN"] = "green200";
  LineChartColors2["ORANGE"] = "orange200";
  LineChartColors2["PURPLE"] = "purple200";
  LineChartColors2["RED"] = "red200";
})(LineChartColors || (LineChartColors = {}));
var ModalKind;
(function(ModalKind2) {
  ModalKind2["GENERAL"] = "general";
  ModalKind2["INFO"] = "info";
  ModalKind2["SUCCESS"] = "success";
  ModalKind2["WARNING"] = "warning";
  ModalKind2["SERIOUS_WARNING"] = "serious-warning";
})(ModalKind || (ModalKind = {}));
var ModalSize;
(function(ModalSize2) {
  ModalSize2["SMALL"] = "small";
  ModalSize2["MEDIUM"] = "medium";
  ModalSize2["LARGE"] = "large";
  ModalSize2["X_LARGE"] = "xlarge";
})(ModalSize || (ModalSize = {}));
class SpsOptionListOption {
  constructor(value, config = {}) {
    this.value = value;
    Object.assign(this, config);
  }
  get text() {
    if (this.textInternal) {
      return this.textInternal;
    }
    if (!this.value) {
      return "";
    }
    return this.textKey ? this.value[this.textKey] : String(this.value);
  }
  set text(value) {
    this.textInternal = value;
  }
  get caption() {
    if (this.captionInternal) {
      return this.captionInternal;
    }
    if (!this.value) {
      return "";
    }
    return this.captionKey ? this.value[this.captionKey] : "";
  }
  set caption(value) {
    this.captionInternal = value;
  }
  get href() {
    if (this.value) {
      return this.value.isLink && typeof this.value === "function" ? this.value() : this.value.href;
    }
    return null;
  }
  get disabled() {
    if (typeof this.disabledInternal !== "undefined") {
      return this.disabledInternal;
    }
    return this.value ? this.value.disabled : false;
  }
  set disabled(value) {
    this.disabledInternal = value;
  }
  get bold() {
    if (typeof this.boldInternal !== "undefined") {
      return this.boldInternal;
    }
    return this.value ? this.value.bold && this.value.bold === true : false;
  }
  getHtml(patternToUnderline) {
    if (patternToUnderline) {
      return this.text.replace(patternToUnderline, "<u>$&</u>");
    }
    return this.text;
  }
}
const DEFAULT_PAGE_SIZE_OPTIONS = [
  10,
  25,
  50,
  100
];
var Position;
(function(Position2) {
  Position2["TOP_LEFT"] = "top left";
  Position2["TOP_MIDDLE"] = "top middle";
  Position2["TOP_RIGHT"] = "top right";
  Position2["RIGHT_TOP"] = "right top";
  Position2["RIGHT_MIDDLE"] = "right middle";
  Position2["RIGHT_BOTTOM"] = "right bottom";
  Position2["BOTTOM_RIGHT"] = "bottom right";
  Position2["BOTTOM_MIDDLE"] = "bottom middle";
  Position2["BOTTOM_LEFT"] = "bottom left";
  Position2["LEFT_BOTTOM"] = "left bottom";
  Position2["LEFT_MIDDLE"] = "left middle";
  Position2["LEFT_TOP"] = "left top";
})(Position || (Position = {}));
var RingSize;
(function(RingSize2) {
  RingSize2[RingSize2["SMALL"] = 14] = "SMALL";
  RingSize2[RingSize2["MEDIUM"] = 26] = "MEDIUM";
  RingSize2[RingSize2["LARGE"] = 38] = "LARGE";
})(RingSize || (RingSize = {}));
var SpinnerSize;
(function(SpinnerSize2) {
  SpinnerSize2["SMALL"] = "small";
  SpinnerSize2["MEDIUM"] = "medium";
  SpinnerSize2["LARGE"] = "large";
})(SpinnerSize || (SpinnerSize = {}));
var StackedBarChartMilestone;
(function(StackedBarChartMilestone2) {
  StackedBarChartMilestone2["BLUE"] = "blue200";
  StackedBarChartMilestone2["GRAY"] = "gray600";
  StackedBarChartMilestone2["GREEN"] = "green200";
  StackedBarChartMilestone2["ORANGE"] = "orange200";
  StackedBarChartMilestone2["PURPLE"] = "purple200";
  StackedBarChartMilestone2["RED"] = "red200";
})(StackedBarChartMilestone || (StackedBarChartMilestone = {}));
var SteppedProgressBarColor;
(function(SteppedProgressBarColor2) {
  SteppedProgressBarColor2["PURPLE"] = "purple";
  SteppedProgressBarColor2["RED"] = "red";
  SteppedProgressBarColor2["BLUE"] = "blue";
  SteppedProgressBarColor2["ORANGE"] = "orange";
  SteppedProgressBarColor2["GRAY"] = "gray";
})(SteppedProgressBarColor || (SteppedProgressBarColor = {}));
var SortDirection;
(function(SortDirection2) {
  SortDirection2["ASCENDING"] = "ascending";
  SortDirection2["DESCENDING"] = "descending";
})(SortDirection || (SortDirection = {}));
var TagKind;
(function(TagKind2) {
  TagKind2["DEFAULT"] = "default";
  TagKind2["KEY"] = "key";
  TagKind2["WARNING"] = "warning";
  TagKind2["ERROR"] = "error";
  TagKind2["PENDING"] = "pending";
  TagKind2["SUCCESS"] = "success";
  TagKind2["INFO"] = "info";
})(TagKind || (TagKind = {}));
const TOOLTIP_HIDE_DELAY_MS_DEFAULT = 1e3;
var TooltipShowTrigger;
(function(TooltipShowTrigger2) {
  TooltipShowTrigger2["MANUAL"] = "manual";
  TooltipShowTrigger2["MOUSEOVER"] = "mouseover";
  TooltipShowTrigger2["CLICK"] = "click";
})(TooltipShowTrigger || (TooltipShowTrigger = {}));
var TooltipKind;
(function(TooltipKind2) {
  TooltipKind2["DEFAULT"] = "default";
  TooltipKind2["HELP"] = "help";
  TooltipKind2["ERROR"] = "error";
  TooltipKind2["WARNING"] = "warning";
  TooltipKind2["CONTAINER"] = "container";
})(TooltipKind || (TooltipKind = {}));
const SPS_ACTION_DEFAULTS = {
  icon: "",
  label: "",
  caption: "",
  disabled: false,
  isLink: false
};
function SpsAction(actionDescriptor) {
  return (target, key, descriptor) => simpleMetadataDecoratorApplicator(actionDescriptor, SPS_ACTION_DEFAULTS, target, key, descriptor);
}
var SpsTaskStatus;
(function(SpsTaskStatus2) {
  SpsTaskStatus2["COMPLETED"] = "completed";
  SpsTaskStatus2["ERRORED"] = "errored";
  SpsTaskStatus2["WARNING"] = "warning";
  SpsTaskStatus2["IN_PROGRESS"] = "in_progress";
})(SpsTaskStatus || (SpsTaskStatus = {}));
const SpsTaskStatusIcons = Object.freeze({
  [SpsTaskStatus.COMPLETED]: SpsIcon.STATUS_OK,
  [SpsTaskStatus.ERRORED]: SpsIcon.STATUS_ERROR,
  [SpsTaskStatus.WARNING]: SpsIcon.STATUS_WARNING,
  [SpsTaskStatus.IN_PROGRESS]: "sps-spinner sps-spinner--small"
});
const TASK_QUEUE_NOTIFICATION_DURATION_MS = 5e3;
var WizardSubstepConditions;
(function(WizardSubstepConditions2) {
  WizardSubstepConditions2["BASIC"] = "basic";
  WizardSubstepConditions2["COMPLETED"] = "completed";
  WizardSubstepConditions2["COMPLETE"] = "completed";
  WizardSubstepConditions2["ACTIVE"] = "active";
})(WizardSubstepConditions || (WizardSubstepConditions = {}));
var ZStratum;
(function(ZStratum2) {
  ZStratum2[ZStratum2["BASE"] = 0] = "BASE";
  ZStratum2[ZStratum2["TIP"] = 10] = "TIP";
  ZStratum2[ZStratum2["DROPDOWN"] = 100] = "DROPDOWN";
  ZStratum2[ZStratum2["BAR"] = 1e3] = "BAR";
  ZStratum2[ZStratum2["DIALOG"] = 1e4] = "DIALOG";
})(ZStratum || (ZStratum = {}));
export { ButtonKind, ButtonType, ClickableTagKind, DEFAULT_PAGE_SIZE_OPTIONS, DropdownKind, FeedbackBlockIcons, FeedbackBlockKind, GROWLER_FADEOUT_DURATION_MS, GROWLER_VISIBLE_DURATION_MS, GrowlerIcon, GrowlerKind, KeyValueListTitleColor, LineChartColors, ModalKind, ModalSize, Position, RingSize, SPS_ACTION_DEFAULTS, SelectMode, SortDirection, SpinnerSize, SpsAction, SpsFilterTileKind, SpsIcon, SpsIconSize, SpsInsightCardIcons, SpsInsightCardKind, SpsInsightTileIcons, SpsInsightTileKind, SpsOptionListOption, SpsTaskStatus, SpsTaskStatusIcons, StackedBarChartMilestone, StdButtonKind, SteppedProgressBarColor, TASK_QUEUE_NOTIFICATION_DURATION_MS, TOOLTIP_HIDE_DELAY_MS_DEFAULT, TagKind, TooltipKind, TooltipShowTrigger, WizardSubstepConditions, ZStratum, exampleIsReactComponentExample, exampleIsReactJSXExample, noI18nI18n };
